import React, {useState} from "react";
import moment from "moment";
import {Card, CardBody, Col, Form, FormGroup, Input, Label, Row, CardTitle} from 'reactstrap';
import {
    ButtonCancel,
    ButtonSubmit,
} from "../../../components/buttons/buttonsActions";
import { useForm } from "react-hook-form";

import {setViewMode, setLoading} from "../../../redux/actions/generalActions/mainActions";
import {resetCombos, setForm, setItem} from "../../../redux/actions/generalActions/formActions";
import {save, update} from "../../../redux/actions/eventx/busDateActions";
import BusDateLangs from "./_langs";
import {connect} from "react-redux";
import {FL_ORDER, FL_DATE, FL_STATUS} from "../../../components/i18n/formLabels";
import { INTERNATIONAL } from "../../../components/i18n/i18n";
import Switch from "react-bootstrap-switch";

const BusDateForm = props => {
    const { editMode, disableInputs, domainObject } = props.formProps;
    const fbDataBaseId = props.mainProps?.app?.fbDataBase?.id

    const [langs, setLangs] = useState(domainObject?.langs || []);
    const [status, setStatus] = useState(domainObject?.status || false);
    const [day, setDay] = useState(domainObject?.day || null);

    const {register, handleSubmit, reset} = useForm({
        defaultValues: {
            id: domainObject?.id,
            uid: domainObject?.uid,
            showOrder: domainObject?.showOrder
        }
    });

    const onSubmit = (data, _) => {
        const dataRequest = {
            noDb : false,
            allDb : false,
            fbDataBase :  { id : fbDataBaseId },
            item : {
                ...data,
                id: domainObject?.id,
                uid: domainObject?.uid,
                day: day ? moment(day).format('YYYY-MM-DD') : null,
                status: status,
                langs: langs,
            }
        };

        try{
            if (editMode) {
                let id = domainObject.id;

                props.update(id, dataRequest)
            } else {
                props.save(dataRequest)
            }
            closeForm()
        } catch (error) {
            console.log(error)
        }
    };

    const closeForm = () => {
        reset();
        props.setItem(null);
        props.setForm();
        props.onClose()
    }

    return <>
        <Card style={{minWidth: '570px'}} >
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="5">
                            <Label>{FL_DATE}</Label>
                            <Input
                                type="date"
                                value={day || ''}
                                disabled={disableInputs}
                                onChange={e => setDay(e.target.value)}
                            />
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label>{FL_STATUS}</Label>
                                <br/>
                                <Switch animate={true} offText={"No"} onText={"Si"}
                                        value={status}
                                        disabled={disableInputs}
                                        onChange={_ => setStatus(!status)}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>{FL_ORDER}</Label>
                                <Input type="number" name="showOrder"
                                       innerRef={register}
                                       disabled={disableInputs}/>
                            </FormGroup>
                        </Col>
                    </Row>
                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                        <i className="fas fa-language mr-2"/>{INTERNATIONAL}
                    </CardTitle>
                    <CardBody>
                        <BusDateLangs langs={langs} setLangs={setLangs} />
                    </CardBody>
                    <CardBody className="border-top">
                        <div className="float-right">
                            <ButtonSubmit/>
                            <ButtonCancel onClick={closeForm}/>
                        </div>
                    </CardBody>
                </Form>
            </CardBody>
        </Card>
    </>

}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
})

const mapActionsToProps = ({
    setViewMode,
    resetCombos,
    setItem,
    setForm,
    save,
    update,
    setLoading
})

export default connect(mapStateToProps, mapActionsToProps)(BusDateForm)
